meedy.factory('meedy.authService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, baseService, objectHelper, config) {

        function MeedyAuthService() {

            this.authenticateToCAS = function (username, password) {
                return baseService.post(config.AUTH_URL_CAS, $.param({j_username: username, j_password: password}), {withCredentials: true, headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.authenticate = function (username, token) {
                return baseService.post(config.AUTH_URL_MEEDY, $.param({username: navigator.userAgent.substr(0,100), grant_type: "password", password: token.token }), {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Authorization' : 'Basic aGVhbHRoY2FyZS1kb2N0b3Itd2ViOkRqUk5qaTNwUDExWTJ0OA=='}}).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.invalidate = function () {
                return baseService.post(config.LOGOUT_URL).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.demo = function () {
                return baseService.post(config.DEMO_URL).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, LoginMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


        }

        return new MeedyAuthService();
    }
]);
